var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form-group",
        {
          staticClass: "mb-1",
          attrs: {
            horizontal: "",
            label: "Кол-во операций на странице",
            "label-for": "inputPerPage",
            "label-cols-sm": "6",
            "label-cols-lg": "3",
            "content-cols-sm": "1",
            "content-cols-lg": "2",
          },
        },
        [
          _c(
            "b-form-select",
            {
              attrs: { id: "inputPerPage", options: _vm.numberOfСolumns },
              on: { input: _vm.changeNumberofPage },
              model: {
                value: _vm.perPage,
                callback: function ($$v) {
                  _vm.perPage = $$v
                },
                expression: "perPage",
              },
            },
            [
              _c("template", { slot: "first" }, [
                _c("option", { domProps: { value: _vm.perPage } }, [
                  _vm._v(_vm._s(_vm.getPages)),
                ]),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.$store.getters.getAdmin ? _c("optionsAdmin") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }